import { render, staticRenderFns } from "./ReceiptPrint.vue?vue&type=template&id=8b3a6404&scoped=true"
import script from "./ReceiptPrint.vue?vue&type=script&lang=js"
export * from "./ReceiptPrint.vue?vue&type=script&lang=js"
import style0 from "./ReceiptPrint.vue?vue&type=style&index=0&id=8b3a6404&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b3a6404",
  null
  
)

export default component.exports